<template>
  <div class="padding-bundles-details">
    <div class="f2g-wind-container">
          <div class="title-bundles-details"> <span v-html="selectedBundle.title"></span></div>
          <div class="mini-title-bundles-details">{{selectedBundle.freeText}}</div>
          <div class="bundle-details">
              <div v-if="showMainCharacteristics">
                <!-- testing -->
              <!-- <div>  -->
                  <div class="main-title-bundles">{{ words['myf2g.dashboard.bundles.details.main'] }}</div>
                  <div class="bundle-f2g list-content-bundles">
                      <div class="details-bundle">
                          <ul>
                             
                              <template v-if="selectedBundle.minutesFirst != null">
                                  <li>
                                      <img src="/ext_files/prepaid/f2g/images/voice.svg" class="svg-list-bundle" />
                                      <span class="strong-item">{{selectedBundle.minutesFirst}}</span>
                                      <span class="item-details" v-html="selectedBundle.toFirst"></span>
                                  </li>
                              </template>

                              <template v-if="selectedBundle.minutesSecond != null">
                                  <li>
                                      <img src="/ext_files/prepaid/f2g/images/voice_wind.svg" class="svg-list-bundle" />
                                      <span class="strong-item">{{selectedBundle.minutesSecond}}</span>
                                      <span class="item-details" v-html="selectedBundle.toSecond"></span>
                                  </li>
                              </template>

                              <template v-if="selectedBundle.sms != null">
                                  <li>
                                      <img src="/ext_files/prepaid/f2g/images/sms.svg" class="svg-list-bundle" />
                                      <span class="strong-item">{{selectedBundle.sms}}</span>
                                      <span class="mini-strong-item">SMS</span>
                                      <span class="item-details" v-html="selectedBundle.smsTo"></span>
                                  </li>
                              </template>

                              <template v-if="selectedBundle.smsSecond != null">
                                  <li>
                                      <img src="/ext_files/prepaid/f2g/images/sms_wind.svg" class="svg-list-bundle" />
                                      <span class="strong-item">{{selectedBundle.smsSecond}}</span>
                                      <span class="mini-strong-item">SMS</span>
                                      <span class="item-details" v-html="selectedBundle.smsSecondTo"></span>
                                  </li>
                              </template>

                              <template v-if="selectedBundle.megaBytes != null || selectedBundle.megaBytesDescription != null">
                                  <li>
                                      <img src="/ext_files/prepaid/f2g/images/data.svg" class="svg-list-bundle" />
                                      <div v-if="selectedBundle.megaBytesDescription">
                                          <span class="strong-item">{{ selectedBundle.megaBytesDescription }}</span>
                                      </div>
                                      <div v-else>
                                          <span class="strong-item">{{formatDataValue(selectedBundle.megaBytes)}}</span>
                                          <span class="mini-strong-item">{{formatDataUnitOfMeasurement(selectedBundle.megaBytes)}}</span>
                                      </div>
                                  </li>
                              </template>

                              <template v-if="selectedBundle.fifthGDescription != null">
                                  <li>
                                      
                                    <img src="/ext_files/prepaid/f2g/images/5g_logo_blue-01.png" style="width: 32px; height: 32px; margin-right: 20px;">
                                    <span class="strong-item"></span>
                                    <span class="item-details" style="font-family: Manrope-Normal; font-size: 14px; padding-left: 0;">{{selectedBundle.fifthGDescription}}</span>

                                    <div class="tooltip" style="top: 3px;">
                                        <svg class="margin-left-5 " width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <desc>Created with Sketch.</desc>
                                            <g id="Icon/Bundle/rollover_tip" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <circle id="Oval" fill-opacity="0.1" fill="#FFFFFF" cx="10" cy="10" r="8"></circle>
                                                <path d="M10.8363586,14.1137164 C10.8363586,15.2954279 9.22572493,15.2954279 9.22572493,14.1137164 C9.22572493,12.9320048 10.8363586,12.9320048 10.8363586,14.1137164 Z M10.764238,5.11328932 C11.8918247,5.44795002 12.5,6.3934768 12.5,7.79222934 L12.5,7.83146611 C12.3923452,9.44631429 11.139623,10.273276 10.2812626,10.5495996 L10.2812626,11.5143488 C10.3169149,11.7505336 10.1561307,11.928263 9.95899275,11.928263 C9.76177961,11.9281409 9.60100257,11.7511914 9.60100257,11.5342371 L9.60100257,10.2540496 C9.60100257,10.0570976 9.72613449,9.89937855 9.88762378,9.86014573 C9.95892832,9.84014329 11.6772167,9.46624189 11.8023093,7.79215056 C11.8023093,6.76815814 11.3905597,6.11805924 10.5852429,5.8818745 C9.5296694,5.5664363 8.52721101,6.07882642 8.20490532,7.12282916 C8.13360077,7.31978108 7.93646637,7.43826735 7.73932481,7.3590139 C7.54218325,7.28054038 7.4527036,7.06358602 7.52471682,6.84662378 C7.97211506,5.44795002 9.36817653,4.70024175 10.764238,5.11328932 Z" id="Combined-Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
                                            </g>
                                        </svg>
                                        <div class="tooltiptext" style="right: -60px;">
                                        
                                                <img src="/ext_files/prepaid/f2g/images/5g_logo_blue-01.png" style="width: 25px;">
                                                <span class="rollover-span" v-html="words['myf2g.dashboard.bundles.details.5gdescription']" style="padding: 0px 0px 5px 10px; color: #ffffff"></span>
                                                <!-- <div class="small-title-bundle" v-html="words['myf2g.bundles.card.label.5gdescription']"></div> -->
                                          
                                        </div>
                                    </div>
                                      
                                  </li>
                              </template>
                          </ul>
                      </div>
                  </div>
              </div>
              <div class="get-win-details" v-if="selectedBundle.bonus != null || selectedBundle.hasGigaButton" :style="[showMainCharacteristics ? '' : {'margin-left':'0px'}]">
                  <div class="main-title-bundles">{{ words['myf2g.dashboard.bundles.details.extra'] }}</div>
                  <div class="win-bundles-details">

                      <template v-if="selectedBundle.bonus != null">
                          <li class="bonus-li">
                              <img src="/ext_files/prepaid/f2g/images/bonus.svg" class="svg-list-bundle" />
                              <div>
                                  <div class="gift-bonus">
                                      BONUS {{selectedBundle.bonus}}
                                  </div>
                                  <div class="gift-days">
                                      {{selectedBundle.bonusDurationDescription}}
                                  </div>
                              </div>
                          </li>
                      </template>

                      <template v-if="selectedBundle.hasGigaButton">
                          <li class="giga-li">
                              <img src="/ext_files/prepaid/f2g/images/giga@2x.png" class="svg-giga svg-list-bundle" />
                              <div class="gift-bonus-text">
                                  <div class="gift-bonus-text-big">{{ words['myf2g.dashboard.bundles.details.gigabutton.title'] }}</div>
                                  <div class="gift-bonus-text-small">{{ words['myf2g.dashboard.bundles.details.gigabutton.info'] }}</div>
                              </div>
                          </li>
                      </template>

                  </div>
              </div>
          </div>
          <div class="remarks-bundles-details remarks-all-bundles" v-if="selectedBundle.notes != null">
              <img src="/ext_files/prepaid/f2g/images/clarifications@2x.png" class="remarks-svg hidden-md hidden-lg" />
              <div class="main-title-bundles hidden-sm hidden-xs">{{ words['myf2g.dashboard.bundles.details.clarifications'] }}</div>
              <div class="remarks-ul hidden-sm hidden-xs" v-html="selectedBundle.notes"></div>
              <div class="main-title-bundles hidden-lg hidden-md" v-on:click="handleClarificationsModal()">{{ words['myf2g.dashboard.bundles.details.clarifications'] }}</div>
          </div>
      </div>
      <div v-bind:class="selectedBundleGroup.isEligibleToActivateBundles?'footer-amount-template':'footer-amount-template bundle-disabled'">
          <div class="f2g-wind-container footer-amount-bundles-details">
            <div class="white-footer">
                <div class="text-amount">{{ words['myf2g.dashboard.bundles.details.price'] }}</div>
                <div class="amount-bundles-details">{{formatCost(selectedBundle.activationCost)}}€</div>
            </div>
            <!-- Activation Button -->
            <div v-if="selectedBundleGroup.isEligibleToActivateBundles" class="blue-footer" >
              <template v-if="selectedBundle.isTopUpBundle">
                  <!-- TopUp Bundle -->
                  <a style="cursor:pointer" v-on:click="redirectToTopupPage(selectedBundle.topUpAmount, selectedBundle.bankDeepLinking)" class="hidden-lg hidden-md"> 
                      <div class="container-button blue-btn ">
                        {{ words['myf2g.bundles.card.label.topup'] }}                  
                      </div>
                  </a>
                  <div class="hidden-sm hidden-xs" v-on:click="redirectToTopupPage(selectedBundle.topUpAmount, selectedBundle.bankDeepLinking)">{{ words['myf2g.bundles.card.label.topup'] }} </div>
              </template>
              <template v-else>
                <!-- Regular Bundle -->
                 <a style="cursor:pointer" v-on:click="activateBundle()" class="hidden-lg hidden-md"> 
                      <div class="container-button blue-btn ">
                        {{ words['myf2g.dashboard.bundles.details.activate'] }}                  
                      </div>
                  </a>
                  <div class="hidden-sm hidden-xs" v-on:click="activateBundle()">{{ words['myf2g.dashboard.bundles.details.activate'] }} </div>
              </template>
            </div>
            <div  v-else class="blue-footer">
              <!-- Disabled Button Small Screen Dimension -->
                <a style="cursor:not-allowed;" class="hidden-lg hidden-md">
                    <div class="container-button blue-btn details-activate-button" style="cursor:not-allowed;">
                      <!-- Topup Bundle Disabled Button Label -->
                      <template v-if="selectedBundle.isTopUpBundle">{{ words['myf2g.bundles.card.label.topup'] }}</template>  
                      <!-- Regular Bundle Disabled Button Label -->
                      <template v-else>{{ words['myf2g.dashboard.bundles.details.activate'] }}</template>         
                    </div>
                </a>
                <!-- Disabled Button Large Screen Dimension -->
                <div class="details-activate-button hidden-sm hidden-xs">
                   <!-- Topup Bundle Disabled Button Label -->
                   <template v-if="selectedBundle.isTopUpBundle">{{ words['myf2g.bundles.card.label.topup'] }}</template>  
                   <!-- Regular Bundle Disabled Button Label -->
                   <template v-else>{{ words['myf2g.dashboard.bundles.details.activate'] }}</template>   
                </div>
            </div>
          </div>
      </div>


      <LoginPrompt v-if="showLoginPrompt"/>
      <ActivateBundle v-if="showActivateBundle"/>
      <SuccessfulActivation v-if="showSuccessfulActivation"/>
      <FailedActivation v-if="showFailedActivation"/>
      <TopUpPrompt v-if="showTopUpPrompt"/>
      <PayLaterModal v-if="showPayLaterModal"/>
      <ClarificationsModal v-if="showClarificationsModal"/>
      <Loader v-if="showLoader"/>

    </div>
</template>

<script>

import store from '@/store/index'
import LoginPrompt from './overlays/LoginPrompt'
import ActivateBundle from './overlays/ActivateBundle'
import SuccessfulActivation from './overlays/SuccessfulActivation'
import FailedActivation from './overlays/FailedActivation'
import TopUpPrompt from './overlays/TopUpPrompt'
import PayLaterModal from './overlays/PayLaterModal'
import Loader from './components/Loader'
import ClarificationsModal from './overlays/ClarificationsModal'

export default {
  name: 'App',
  components: {
    LoginPrompt,
    ActivateBundle,
    SuccessfulActivation,
    FailedActivation,
    TopUpPrompt,
    PayLaterModal,
    Loader,
    ClarificationsModal
  },
  data() {
    return {
      words: {}
    }
  },
  computed: {
    locale() {
      return document.getElementsByTagName('body')[0].getAttribute('data-locale') || 'el_GR';
    },
    username() {
      return store.state.username;
    },
    isLoggedIn() {
      return store.state.isLoggedIn;
    },
    bundleGroups() {
      return store.state.bundleGroups;
    },
    selectedBundle() {
      return store.state.selectedBundle;
    },
    selectedBundleGroup() {
      return store.state.selectedBundleGroup;
    },
    showLoginPrompt() {
      return store.state.showLoginPrompt;
    },
    showActivateBundle() {
      return store.state.showActivateBundle;
    },
    showSuccessfulActivation() {
      return store.state.showSuccessfulActivation
    },
    showFailedActivation() {
      return store.state.showFailedActivation
    },
    showTopUpPrompt() {
      return store.state.showTopUpPrompt;
    },
    showLoader() {
      return store.state.showLoader;
    },
    showPayLaterModal() {
      return store.state.showPayLaterModal;
    },
    showClarificationsModal() {
      return store.state.showClarificationsModal;
    },
    showMainCharacteristics() {
      return ( this.selectedBundle.minutesFirst != null || 
               this.selectedBundle.minutesSecond != null || 
               this.selectedBundle.sms != null || 
               this.selectedBundle.smsSecond != null || 
               this.selectedBundle.megaBytes != null || this.selectedBundle.megaBytesDescription != null)
    }

  },
  beforeMount() {

    if ( sessionStorage.getItem("wcs_myf2bundledetails_"+this.locale) != null ) {
      this.words = JSON.parse(sessionStorage.getItem("wcs_myf2bundledetails_"+this.locale));
    } else {
      
      let config = {
        method: 'get',
        url: '/gr/f2g/vueContentService/',
        params: {
          ciKey: 'myf2bundledetails',
          locale: this.locale,
        }
      }
      
      let self = this;
      this.axios(config).then(function(response){
        console.log(response);
        self.words = response.data;
        sessionStorage.setItem("wcs_myf2bundledetails_"+self.locale, JSON.stringify(self.words));

      }).catch(function(error){
        console.error(error);
      })

    }
    //Initiate app vars
    this.initAppVars();
    this.getBundles();

    if (this.readCookie("prepaidDL") !== null) {
      if (document.getElementById('user-info').getAttribute('data-is-logged-in') == "true") {
         // if istopup redirect and dont show prompt
         var bundleInfo = JSON.parse(sessionStorage.getItem("BundleInfo"));
        if(bundleInfo.isTopUpBundle){
          this.redirectForTopUp(bundleInfo.topUpAmount, bundleInfo.bankDeepLinking);
        }else
        this.redirectActivateBundle();
      } else {
        sessionStorage.removeItem("BundleInfo");
        this.deleteCookie("prepaidDL");
      }
    }

  },
  methods: {
    initAppVars() {
      let locale = document.getElementsByTagName('body')[0].getAttribute('data-locale') || 'el_GR';
      let isDevMode = document.getElementsByTagName("BODY")[0].getAttribute("data-devmode") == "true" || false;

      let username = document.getElementById('user-info').getAttribute('data-username') || 'anonymous';
      let msisdn = document.getElementById('user-info').getAttribute('data-msisdn');
      let isLoggedIn = (document.getElementById('user-info').getAttribute('data-is-logged-in') == "true") || false;
      let isOtpUser = (document.getElementById('user-info').getAttribute('data-otpuser') == "true") || false;

      store.commit('locale', locale);
      store.commit("isDevMode", isDevMode);
      
      store.commit('username', username);
      store.commit('msisdn', msisdn);
      store.commit('isLoggedIn', isLoggedIn);
      store.commit("isOtpUser", isOtpUser);
    },
    formatCost(val) {

        val = parseFloat(val).toFixed(2);

        if (this.locale == "en_US") {
            return val.toLocaleString('en-US');
        } else {
            return val.toLocaleString('el-GR');
        }
    },
    activateBundle() {
        if (this.isLoggedIn) {
          store.commit("showActivateBundle", true);
        } else {
          store.commit("showLoginPrompt", true);
        } 
    },
    redirectToTopupPage(topUpAmount, bankDeepLinking){
      if(!this.isLoggedIn){
        store.commit("showLoginPrompt", true);
      }else{
        var url;
        var params="";
        if (topUpAmount){
          params="?amount="+topUpAmount+"&bankDeepLinking="+bankDeepLinking
        }
        if (this.locale == "en_US") {
            url = "/en/f2g/upiresies/online-ananeosi-hronou-omilias/online-ananeosi-hronou-omilias-meso-myf2g-/"+params;
        } else {
            url = "/gr/f2g/upiresies/online-ananeosi-hronou-omilias/online-ananeosi-hronou-omilias-meso-myf2g-/"+params;
        }
        window.location.href = url;
      }
    },
    redirectForTopUp (topUpAmount, bankDeepLinking){
      var url;
      var params="";
      if (topUpAmount){
          params="?amount="+topUpAmount+"&bankDeepLinking="+bankDeepLinking
      }
      if (this.locale == "en_US") {
          url = "/en/f2g/upiresies/online-ananeosi-hronou-omilias/online-ananeosi-hronou-omilias-meso-myf2g-/"+params;
      } else {
          url = "/gr/f2g/upiresies/online-ananeosi-hronou-omilias/online-ananeosi-hronou-omilias-meso-myf2g-/"+params;
      }
      sessionStorage.removeItem("BundleInfo");
      this.deleteCookie("prepaidDL");
      window.location.href = url;
    },
    getBundles() {

      //build request
      let request = {
        includeTopUpBundles:true,
        caller: {
            callingSystem: "myF2Gweb",
            salesCode: "",
            username: this.username,
            locale: this.locale,
            channel: "F2G"
        }
      }

      //build axios config
      let config = {
        method: 'post',
        url: '/apiv2/bundles/getBundles/',
        data: request
      }

      //make axios call
      let self = this;

      store.commit("showLoader",true);
      this.axios(config).then(function(response){

        if (response.data.errorLevel === 0) {

          self.setSelectedBundle(response.data.bundleGroups);

          
          
        } else {
          //Handle error case;
        }


      }).catch(function(error){
        console.error(error);
      }).finally(function(){
        store.commit("showLoader",false);
      })

    },
    setSelectedBundle(bundleGroups) {
      var bundleGroupUrl = this.$route.query.bundleurl
      this.setChangeLocaleUrlPath(this.$route.query.bundleurl);

      bundleGroups.forEach(function(bundleGroup){
        bundleGroup.bundles.forEach(function(bundle){

          if(bundle.friendlyUrl == bundleGroupUrl) {
            store.commit("selectedBundle", bundle);
            store.commit("selectedBundleGroup", bundleGroup);
            
          }

        })
      })

    },
    formatDataValue(value) {

        var unitGB = 1000;

        if (value >= unitGB) {
            return value / unitGB;
        } else {
            return value;
        }
    },
    formatDataUnitOfMeasurement(value) {

        var unitGB = 1000;

        if (value >= unitGB) {
            return "GB"
        } else {
            return "MB";
        }

    },
    handleClarificationsModal() {
      store.commit("showClarificationsModal", true)
    },
    setChangeLocaleUrlPath(path) {


       var currentUrl = $(".lang-icon-header a").attr("href");

        if (currentUrl.includes("#/?bundleurl=")) {
            var newUrl = currentUrl+path;
        } else {
            var newUrl = currentUrl + "#/?bundleurl="+path;
        }

        $(".lang-icon-header a").attr("href", newUrl); 
    },
    readCookie(cookieName) {
      var nameEQ = cookieName + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
    },
    deleteCookie(cookieName) {
      if (this.readCookie(cookieName) !== null) {
        document.cookie = cookieName + "=" + ";expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
      }
    },
    redirectActivateBundle () {
        var bundleInfo = JSON.parse(sessionStorage.getItem("BundleInfo"));
        sessionStorage.removeItem("BundleInfo");
        this.deleteCookie("prepaidDL");
        store.commit("selectedBundle", bundleInfo);
        store.commit("showActivateBundle", true);
    }
  }

}
</script>
